import { render, staticRenderFns } from "./SwitchWire.vue?vue&type=template&id=71439b4f"
import script from "./SwitchWire.vue?vue&type=script&lang=js"
export * from "./SwitchWire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports